import React, { useEffect, useState,useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Toast from "./Toast";
import { Editor } from '@tinymce/tinymce-react';


import { loadMasterData } from "../utils/loadMasterData";

import localProjectStages from "../data/projectStages.json";
import localFundingStages from "../data/fundingStages.json";
import localTechnologies from "../data/technologies.json";
import localIndustryStages from "../data/industryStages.json";

export default function PfTitle({onDirtyChange}) {

  const navigate = useNavigate();
  const { id } = useParams();
  const [initialForm, setInitialForm] = useState({});
  const [form, setForm] = useState({ vision: "" });
  const [isDirty, setIsDirty] = useState(false);
  const [loading, setLoading] = useState(false);
  const [saveMessage, setSaveMessage] = useState("");
  const [saveType, setSaveType] = useState("success");
  const [confirmIndex, setConfirmIndex] = useState(null);

  const [projectStages, setProjectStages] = useState(localProjectStages);
  const [fundingStages, setFundingStages] = useState(localFundingStages);
  const [technologies, setTechnologies] = useState(localTechnologies);
  const [industryStages, setIndustryStages] = useState(localIndustryStages);

  // Load dropdown master data
  useEffect(() => {
    (async () => {
      setProjectStages(await loadMasterData("projectStages.json", localProjectStages));
      setFundingStages(await loadMasterData("fundingStages.json", localFundingStages));
      setTechnologies(await loadMasterData("technologies.json", localTechnologies));
      setIndustryStages(await loadMasterData("industryStages.json", localIndustryStages));
    })();
  }, []);


const editorRef = useRef(null);


  useEffect(() => {
    if (!id) return;
    fetch(`${process.env.REACT_APP_API_BASE_URL}/projects`)
      .then((res) => res.json())
      .then((data) => {
        const project = (data.lists || []).find((p) => String(p.id) === String(id));
        if (project) {

          setForm({ 
            title: project.title || "",
            title_image: project.title_image || "",
            short_description: project.short_description,
            description: project.description,
            category: project.category,
            client: project.client,
            project_stage: project.project_stage,
            funding_stage: project.funding_stage,
            industry_stage: project.industry_stage || "",
            technology: project.technology || "",
          });
          setInitialForm({
            title: project.title || "",
            title_image: project.title_image || "",
            short_description: project.short_description,
            description: project.description,
            category: project.category,
            client: project.client,
            project_stage: project.project_stage,
            funding_stage: project.funding_stage,
            industry_stage: project.industry_stage || "",
            technology: project.technology || "",
          });
        }
      });
  }, [id]);

    useEffect(() => {
    const formChanged = JSON.stringify(form) !== JSON.stringify(initialForm);
    setIsDirty(formChanged);
  }, [form]);

    const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSaveMessage("");

    const fd = new FormData();
  Object.entries(form).forEach(([k, v]) => {
   fd.append(k, v);
  });


    if (id) fd.append("id", id);
    const endpoint = id ? "updateProject" : "addProject";

    try {
      const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/${endpoint}`, {
        method: "POST",
        headers: { Authorization: `Bearer ${process.env.REACT_APP_ADMIN_TOKEN}` },
        body: fd,
      });

      const text = await res.text();
      const data = JSON.parse(text || "{}");

      if (data.success) {
        setInitialForm(form);
        setSaveMessage("✅ Saved successfully!");
        setSaveType("success");

       if (onDirtyChange) onDirtyChange(true);

      } else {
        setSaveMessage("❌ Save failed");
        setSaveType("error");
      }
    } catch (err) {
      console.error("Network error:", err);
      setSaveMessage("❌ Network error");
      setSaveType("error");
    } finally {
      setLoading(false);
      setIsDirty(false);
    }
  };


useEffect(() => {
    if (typeof onDirtyChange === "function") {
      onDirtyChange(isDirty);
    }
  }, [isDirty]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

 const handleCancel = () => {
    setForm(initialForm);
    setSaveMessage("");
    if (onDirtyChange) onDirtyChange(false);
  };

  const handleEditorChange = (content, editor) => {
  setForm((prev) => ({ ...prev, description: content }));
};


  return (
    <div className="">

      <form
        onSubmit={handleSubmit}
        style={{
          border: isDirty ? "2px dotted red" : "none",
          padding: "10px",
        }}
      >
 <div className="w3-right w3-row" style={{ marginTop: 20 }}>
          <button
            className="w3-button w3-teal w3-wide"
            type="submit"
            disabled={!isDirty || loading}
          >
            {loading ? "Saving..." : "Save"}
          </button>
          <button
            type="button"
            className="btn-muted"
            style={{ marginLeft: 8 }}
            onClick={handleCancel}
          >
            Cancel
          </button>
        </div>


    <div className="form-row w3-row ">
          <label>Title</label>
          <input name="title" value={form.title} onChange={handleChange} required />
        </div>

        <div className="form-row">
          <label>Short Description</label>
          <input name="short_description" value={form.short_description} onChange={handleChange} />
        </div>



        <div className="form-row" style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
          
          <div style={{ flex: 1, minWidth: 200 }}>
            <label>Industry</label>
            <select name="industry_stage" value={form.industry_stage} onChange={handleChange}>
              <option value="">Select Industry Stage</option>
              {industryStages.map((s) => (
                <option key={s}>{s}</option>
              ))}
            </select>
          </div>

          <div style={{ flex: 1, minWidth: 200 }}>
            <label>Technology</label>
            <select name="technology" value={form.technology} onChange={handleChange}>
              <option value="">Select Technology</option>
              {technologies.map((t) => (
                <option key={t}>{t}</option>
              ))}
            </select>
          </div>

          <div style={{ flex: 1, minWidth: 200 }}>
            <label>Project Stage</label>
            <select name="project_stage" value={form.project_stage} onChange={handleChange}>
              {projectStages.map((s) => (
                <option key={s}>{s}</option>
              ))}
            </select>
          </div>

          <div style={{ flex: 1, minWidth: 200 }}>
            <label>Funding Stage</label>
            <select name="funding_stage" value={form.funding_stage} onChange={handleChange}>
              {fundingStages.map((s) => (
                <option key={s}>{s}</option>
              ))}
            </select>
          </div>
  </div>



    <div className="form-row">
          <label>Research / Academia </label>
          <input name="category" value={form.category} onChange={handleChange} required />
        </div>



    <div className="form-row">
          <label> More Information</label>
          <input name="client" value={form.client} onChange={handleChange} required />
        </div>


<div className="form-row" >
    <label>Description</label>
    <Editor
    apiKey="otom8o4ij4qh797vgpjact577mt61cp0mc0legnpz0k4u1rg"
    value={form.description}
    onEditorChange={handleEditorChange}
    onInit={(evt, editor) => (editorRef.current = editor)}
    init={{
    height: 400,
    menubar: false,
    plugins: ['link', 'lists', 'code'],
    toolbar: 'undo redo | bold italic underline | bullist numlist | link | code',
    }}
    />
  </div>

        <div className="" style={{ marginTop: 20 }}>
          <button
            className="w3-button w3-teal w3-wide"
            type="submit"
            disabled={!isDirty || loading}
          >
            {loading ? "Saving..." : "Save"}
          </button>
          <button
            type="button"
            className="btn-muted"
            style={{ marginLeft: 8 }}
            onClick={handleCancel}
          >
            Cancel
          </button>
        </div>

        <Toast
          message={saveMessage}
          type={saveType}
          onClose={() => setSaveMessage("")}
        />
      </form>
</div>
  );
}
